/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T10:19:46.05
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listCCBFinBillItem,
	listCCBFinBillItemInit,
	listCCBFinBillItemByAuthorizations,
	deleteCCBFinBillItem
} from '@api/house/CCBFinBillItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listCCBFinBillItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBFinBillItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listCCBFinBillItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBFinBillItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listCCBFinBillItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBFinBillItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteCCBFinBillItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteCCBFinBillItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
